// extracted by mini-css-extract-plugin
export default {"item-wrapper":"styles_item-wrapper__ICsMw","item":"styles_item__ImqPC","image":"styles_image__8H1xq"};